export const SSR_APP_ID = 'hdms-website';

export const APP_FOOTER_SELECTOR = 'website-footer';
export const APP_CONTENT_SELECTOR = 'website-content';
export const HDMS_MAIN_SELECTOR = 'main';
